import { render, staticRenderFns } from "./RegistrationsDownload.vue?vue&type=template&id=222317a0&"
import script from "./RegistrationsDownload.vue?vue&type=script&lang=js&"
export * from "./RegistrationsDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports